<template>
  <input
    :name="name"
    :value="modelValue"
    v-bind="$attrs"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
      required: false
    },
    name: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue']
};
</script>
